import { createClient } from '@sanity/client';
import { createImageUrlBuilder } from '@sanity/image-url';

import { sanityDataset, sanityProjectId, useCdn } from './constants';

export const sanityClient = createClient({
  projectId: sanityProjectId,
  dataset: sanityDataset,
  apiVersion: '2025-09-09',
  useCdn: useCdn,
});

// CDN-backed twin of `sanityClient` for queries where a few seconds of edge
// staleness is acceptable in exchange for a much faster response. In prod this
// is functionally identical to `sanityClient` (which is already CDN-backed);
// in dev/qa it opts out of the "always origin" default so time-critical reads
// (e.g. the native homepage hero) still hit `apicdn.sanity.io`.
export const sanityCdnClient = sanityClient.withConfig({ useCdn: true });

export {
  loyaltyHomepageConfigWebQuery,
  loyaltyHomepageConfigAppQuery,
} from './queries/loyalty-homepage-config';

export { nativeHomepageHeroQuery } from './queries/native-homepage-hero';

export const imageUrlBuilder = createImageUrlBuilder(sanityClient);

export type * from '../sanity.types';
